export const settingsPath = {
  /* inject path */
  RELEASE_NOTES_DETAILS: '//release-notes-details',
  NOTIFICATIONS_SETTINGS: '/settings/notifications-settings',
  USER_SETTINGS: '/settings/user-settings',
  FREQUENTLY_ASKED_QUESTION: '/settings/frequently-asked-question',
  SETTINGS: '/settings/settings',
  NOTIFICATIONS: '/settings/notifications',
  RELEASE_NOTES: '/settings/release-notes',
  ADD_RELEASE_NOTES: '/settings/add-release-notes',
  EDIT_RELEASE_NOTES: '/settings/edit-release-notes/:id',
  EDIT_RELEASE_NOTES_URL: '/settings/edit-release-notes',
  RELEASE_NOTES_DETAILS: '/settings/release-notes-details/:id',
  RELEASE_NOTES_DETAILS_URL: '/settings/release-notes-details',
};
